<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">
                {{ $t('paymentStatistic.pageTitle') }}
            </h1>
            <ts-breadcrumb :items="[
                { text: $t('toHomePage'), href: '/' },
                {
                    text: $t('paymentStatistic.pageTitle'),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <div class="row">
                    <div class="col-md-1">
                        <label class="form-label col-label required">{{ $t('paymentStatistic.branch') }}</label>
                        <a-select style="width:100%" v-model="model.branch_id" :options="branchs" showSearch
                            :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')"
                            @change="onBranchChange">
                        </a-select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="col-lable for-label required">{{ $t('paymentStatistic.acYear') }}</label>
                        <a-select v-model="model.ac_year_id" :show-search="true" :placeholder="$t('all')" :filterOption="(input, option) =>
                            option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            " :maxTagCount="1" :maxTagTextLength="17" :options="years" @change="onYearChange"
                            style="width: 100%;">
                        </a-select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="for-label col-label">{{ $t('paymentStatistic.mainProgram') }}</label>
                        <a-select v-model="model.acp_id" :options="main_programs" :placeholder="$t('all')"
                            style="width: 100%" showSearch mode="multiple" :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1" @change="onMainProgramChange">
                        </a-select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="col-label for-label">{{ $t('paymentStatistic.subProgram') }}</label>
                        <a-select v-model="model.acps_id" :options="sub_programs" :placeholder="$t('all')"
                            style="width: 100%" showSearch mode="multiple" :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1" @change="onSubProgramChange">
                        </a-select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="col-label for-label"> {{ $t('paymentStatistic.acTerm') }}</label>
                        <a-select v-model="model.ac_term_id" :options="ac_terms" :placeholder="$t('all')"
                            style="width: 100%" showSearch mode="multiple" :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1" @change="onTermChange">
                        </a-select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <label class="col-label for-label"> {{ $t('paymentStatistic.class') }}</label>
                        <a-select v-model="model.class_id" :options="class_options" :placeholder="$t('all')"
                            style="width: 100%" showSearch mode="multiple" :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1">
                        </a-select>
                    </div>
                    <div class="col-md-auto mt-4 flex align-items-center ms-auto">
                        <a-button color="success" :loading="viewing" @click.prevent="viewDetails"
                            :disabled="!model.ac_year_id">
                            {{ $t('paymentStatistic.view') }}
                        </a-button>
                    </div>


                </div>

            </ts-card-wrapper>
            <div class="overflow-auto">
                <Table :columns="columns" :data="resources" size="small" :loading="viewing" max-height="600"
                    ref="selection" striped>

                </Table>
            </div>
            <div class="d-flex justify-content-end p-15">
                <ts-pagination v-model="pagination" @navigate="viewDetails"></ts-pagination>
            </div>
        </ts-card>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import expandRow from './table-expand.vue'

export default {
    name: 'payment-statistic',

    data() {
        return {
            loading: false,
            acpLoading: false,
            acTermLoading: false,
            acpsLoading: false,
            viewing: false,
            classLoading: false,
            visible: false,
            years: [],
            ac_terms: [],
            main_programs: [],
            sub_programs: [],
            class_options: [],
            branchs: [],
            model: {
                ac_year_id: null,
                ac_term_id: [],
                acp_id: [],
                acps_id: [],
                class_id: [],
                branch_id: null
            },
        }
    },
    computed: {
        ...mapState('paymentStatistic', ['resources', 'pagination']),

        columns() {
            return [
                {
                    type: 'expand',
                    render: (h, params) => {
                        const row = params.row;
                        const paid = row.paid_students || [];
                        const unpaid = row.unpaid_students || [];
                        return h(expandRow, {
                            props: {
                                paidStudents: paid,
                                unpaidStudents: unpaid
                            },
                            on: { cancel: this.viewDetails }
                        });
                    },
                    width: 30
                },

                {
                    title: this.$t('paymentStatistic.class'),
                    key: 'class_name',
                    width: 250
                },
                {
                    title: this.$t('paymentStatistic.subProgram'),
                    key: 'acps_name',
                    width: 250
                },
                {
                    title: this.$t('paymentStatistic.acTerm'),
                    key: 'term_name',
                    width: 250
                },
                {
                    title: this.$t('paymentStatistic.acYear'),
                    key: 'ac_year',
                    width: 250
                },
                {
                    title: this.$t('paymentStatistic.toTalStudent'),
                    key: 'total_student',
                    width: 250,
                    align: 'center',
                },
                {
                    title: this.$t('paymentStatistic.toTalPaid'),
                    key: 'total_paid',
                    width: 250,
                    align: 'center',
                },
                {
                    title: this.$t('paymentStatistic.toTalUnPaid'),
                    key: 'total_unpaid',
                    width: 250,
                    align: 'center',
                }
            ]
        },
    },
    created() {
        this.model.branch_id = [this.$store.state.authUser.default_branch_id]
        this.fetchYear();
        this.fetchMainPrograms();
        this.getBranch()
    },
    methods: {
        ...mapActions('paymentStatistic', ['getTerm', 'getMainProgram', 'getSubProgram', 'getClass']),

        onBranchChange() {
            this.model.ac_year_id = null;
            this.years = [];
            this.fetchYear();
        },
        fetchYear() {
            this.loading = true;
            this.$store
                .dispatch('paymentStatistic/getYear', {
                    filter: {
                        branch_id: this.model.branch_id
                    }
                }).then(response => {
                    this.years = response.data.map(el => ({
                        value: el.ac_year_id,
                        label: el.ac_year +
                            (el.ac_status_id == 1 ? ' (Current)' :
                                el.ac_status_id == 2 ? ' (History)' : ' (Next)')
                    }));
                })
                .catch(error => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async fetchMainPrograms() {
            this.acpLoading = true;
            await this.getMainProgram()
                .then(response => {
                    this.main_programs = response.data.map(el => ({
                        value: el.acp_id,
                        label: el.acp_name_foreign
                    }));
                })
                .catch(error => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    this.acpLoading = false;
                });
        },

        onYearChange() {
            this.ac_terms = [];
            this.model.ac_term_id = [];
            this.model.acp_id = [];
            this.model.acps_id = [];
            this.model.class_id = [];
            this.sub_programs = [];
            this.class_options = [];
        },

        fetchTerm() {
            this.acTermLoading = true;
            return this.getTerm({
                filter: {
                    acps_id: this.model.acps_id,
                    ac_year_id: this.model.ac_year_id,
                },
            })
                .then(response => {
                    this.ac_terms = _.sortBy(response.data, ['ac_status_id']).map(el => ({
                        value: el.ac_term_id,
                        label:
                            el.term_name +
                            (el.ac_status_id == 1
                                ? ' (Current)'
                                : el.ac_status_id == 2
                                    ? ' (History)'
                                    : ' (Next)')
                    }));
                })
                .catch(error => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    this.acTermLoading = false;
                });
        },

        onTermChange(ac_term_id) {
            this.classLoading = true;
            this.model.class_id = [];
            this.class_options = [];

            if (!ac_term_id || ac_term_id.length === 0) {
                this.loading = false;
                return;
            }

            this.getClass({
                filter: {
                    ac_term_id: ac_term_id,
                    branch_id: this.model.branch_id
                },
            })
                .then(response => {
                    this.class_options = response.data.map(el => ({
                        value: el.class_id,
                        label:
                            el.class_name +
                            ' | ' +
                            el.teacher.full_name_en +
                            ' | ' +
                            el.academic_study_time.study_time
                    }));
                })
                .catch(error => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    this.classLoading = false;
                });
        },

        onMainProgramChange() {
            this.sub_programs = [];
            this.ac_terms = [];
            this.class_options = [];
            this.model.acps_id = [];
            this.model.ac_term_id = [];
            this.model.class_id = [];
            this.paidStudents = [];
            this.unpaidStudents = [];
            this.hasSearched = false;

            if (this.model.acp_id && this.model.acp_id.length > 0) {
                this.fetchSubPrograms();
            }
        },

        fetchSubPrograms() {
            this.acpsLoading = true;
            this.getSubProgram({
                filter: {
                    acp_id: this.model.acp_id
                }
            })
                .then(response => {
                    this.sub_programs = response.data.map(el => ({
                        value: el.acps_id,
                        label: el.acps_name_foreign,
                        scoring_cycles: el.scoring_cyles ? el.scoring_cyles.map(cycle => cycle.scoring_cycle_id) : []
                    }));
                })
                .catch(error => {
                    this.$toasted.error(error.message);
                })
                .finally(() => {
                    this.acpsLoading = false;
                });
        },

        onSubProgramChange() {
            this.ac_terms = [];
            this.class_options = [];
            this.model.ac_term_id = [];
            this.model.class_id = [];
            this.paidStudents = [];
            this.unpaidStudents = [];
            this.hasSearched = false;

            if (this.model.acps_id && this.model.acps_id.length > 0) {
                this.fetchTerm();
            }
        },
        getBranch() {
            this.$store
                .dispatch('user/getBranch', {
                    filter: {
                        user_branches: true
                    }
                })
                .then(response => {
                    this.branchs = response.data.map(el => ({
                        value: el.branch_id,
                        label: el.branch_name_en
                    }))
                })
        },
        viewDetails(attributes = {}) {

            this.viewing = true
            this.$store
                .dispatch(
                    'paymentStatistic/fetch',
                    Object.assign(
                        {
                            branch_id: this.model.branch_id,
                            ac_year_id: this.model.ac_year_id,
                            ac_term_id: this.model.ac_term_id,
                            acp_id: this.model.acp_id,
                            acps_id: this.model.acps_id,
                            class_id: this.model.class_id
                        },
                        { ...attributes }
                    )
                )
                .then(() => {
                    this.viewing = false
                })
                .catch(error => {
                    this.viewing = false
                    this.$toasted.error(error.message)
                })
        },

    },

}
</script>